import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const { setEmergencyContactFormField } = props

    const onChangeFormField = fieldName => event => {
      setEmergencyContactFormField(fieldName, event.target.value)
    }

    return <WrappedComponent onChangeFormField={onChangeFormField} {...props} />
  }
}

export default withEventHandlers
